import React from 'react';
import heroImage from '../Images/image.png';

const Background = () => {
  return (
    <>
      {/* Background Layer - optimized with will-change and contain */}
      <div 
        className="fixed inset-0 z-0 h-full w-full bg-cover bg-center bg-no-repeat opacity-60"
        style={{ 
          backgroundImage: `url(${heroImage})`,
          willChange: 'auto',
          contain: 'strict',
          transform: 'translateZ(0)'
        }}
      ></div>
      <div 
        className="fixed inset-0 z-0 bg-gradient-to-t from-background-dark via-background-dark/80 to-transparent"
        style={{ 
          contain: 'strict',
          transform: 'translateZ(0)'
        }}
      ></div>
    </>
  );
};

export default Background;
